import styled, { css } from 'styled-components';
import { em } from '../../styles';
import { typographyStyle } from '../../components/_shared/Typography';
import { Link } from '../../components/_shared/Link';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  padding: 20px;
`;

export const SettingsContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 1em;
`;

export const SettingContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-content: start;
  gap: 1em;
`;
export const Table = styled.table`
  width: 100%;
`;

export const TableHeader = styled.th`
  text-align: left;
  padding-left: 1em;
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #ccc;
  margin: 0.5em;
`;

export const TableCell = styled.td`
  padding: 1em;
`;
